import i18next from 'i18next'
import 'reflect-metadata'
import {injectable} from 'inversify'
import {action, makeObservable, observable} from 'mobx'
import {Tab} from '@/components/dumb/Tabs/props'
import {TRangePickerContainerStore, TTabsContainerStore} from '@/components'
import {hasPermissions} from '@/stores/auth/services'
import {PermissionsMap} from '@/stores/auth/constants/permissions-map'

@injectable()
export class OverviewTabsContainerStore implements TTabsContainerStore {
    tabs: Tab[]
    value: 'onlinePayments' | 'posPayments' | 'settlements' | 'payments'
    _rangePickerStore: TRangePickerContainerStore

    constructor() {
        this.tabs = [
            hasPermissions([
                PermissionsMap.pos_payments.read,
                PermissionsMap.pos_payments.full
            ]) && {title: i18next.t('Overview.posPayments'), disabled: false, key: 'posPayments'},
            hasPermissions([
                PermissionsMap.online_payments.read,
                PermissionsMap.online_payments.full
            ]) && {
                title: i18next.t('Overview.onlinePayments'),
                disabled: false,
                key: 'onlinePayments'
            },
        ].filter((tab) => !!tab)

        this.value = hasPermissions([
            PermissionsMap.pos_payments.read,
            PermissionsMap.pos_payments.full
        ])
            ? 'posPayments'
            : 'onlinePayments'

        makeObservable(this, {
            value: observable,
            tabs: observable,
            setValue: action.bound
        })
    }

    public clear() {
        this.value = null
    }

    setValue(value) {
        this.value = value
    }

    public setTabs(tabs: Tab[]): void {
        this.tabs = tabs
    }
}
